import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosHttp from 'services/axiosHttp';
import dayjs from 'dayjs';

export const fetchQrScanLogList = createAsyncThunk('qrScanLogList/fetchQrScanLogList', async (filters = {}, { rejectWithValue }) => {
    try {
      const params = {
        keyword: filters.keyword || undefined,
        department: filters.department || undefined,
        date_start: filters.date ? dayjs(filters.date).format('YYYY-MM-DD') : undefined,
        date_end: filters.date ? dayjs(filters.date).format('YYYY-MM-DD') : undefined
      };
      
      const response = await axiosHttp.get('lcqr/getcanlogs', { params });
      
      if (response.data && response.data.success) {
        return  {
          data: response.data.data || [],
          count: response.data.count || 0,
        };
      } else {
        return rejectWithValue(response.data?.message || 'Failed to fetch QR Scan Logs');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Something went wrong');
    }
  }
);

const qrScanLogListSlice = createSlice({
  name: 'QrScanLogListSlice',
  initialState: {
    data: [],
    count: 0,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQrScanLogList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQrScanLogList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.count = action.payload.count;
      })
      .addCase(fetchQrScanLogList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default qrScanLogListSlice.reducer;